/* eslint-disable */
import {
  createStyles,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Theme,
  withStyles,
  Button,
  Container,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Avatar,
  Divider,
  Card,
  CardContent,
  Link,
  Fab,
  Typography,
  Tooltip,
  CardHeader,
  IconButton,
  CardActions,
} from "@material-ui/core";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  getRootDocumentsAndDirectories,
  getDirectoryDocuments,
  getDocument,
  deleteDocument,
  deleteDirectory,
} from "../../utils/store/actions/document.actions";
import { show } from "redux-modal";
import { document_uri } from "./../../utils/uri";
import axios from "axios";

import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import FolderIcon from "@material-ui/icons/Folder";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ModalAddDocumentInDirectory from "../../components/Modal/Modal.AddDocumentInDirectory";
import { AiOutlineFilePdf } from "react-icons/ai";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import FileDownload from "js-file-download";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteIcon from "@material-ui/icons/Delete";
import { styles } from "./styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";

class Funds extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      rootDirectories: [],
      rootDocuments: [],
      breadcrumbsFiles: [""],
      breadcrumbs: [""],
      node: "root",
      parentDirectoryId: "",
      loading: false,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.props
      .getRootDocumentsAndDirectories()
      .then(() => this.setState({ loading: false }));
  }
  handleTreeItem(id: any, index: any) {
    if (index === "root") {
      this.setState({ node: index, parentDirectoryId: "" });
    } else {
      this.props.getDirectoryDocuments(id);
      this.setState({ node: index + 2, parentDirectoryId: id });
    }
  }
  handlePreview(file: any) {
    axios({
      method: "get",
      url: `${document_uri}/service-document/v1/shared-documents/documents/${file.id}`,
      responseType: "blob",
    }).then((res: any) => {
      this.setState({
        file: URL.createObjectURL(res.data),
        blob: res.data,
        fileName: file.name,
        open: true,
      });
      var element = document.createElement("a");
      element.href = this.state.file;
      element.setAttribute("download", `${file.name}`);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    });
  }
  handleDeleteDocument(id: any) {
    this.props.deleteDocument(id).then(() => {
      if (this.state.parentDirectoryId === "") {
        this.props.getRootDocumentsAndDirectories();
      } else {
        this.props.getDirectoryDocuments(this.state.parentDirectoryId);
      }
    });
  }
  handleDeleteDirectory(id: any) {
    this.props.deleteDirectory(id).then(() => {
      if (this.state.parentDirectoryId === "") {
        this.props.getRootDocumentsAndDirectories();
      } else {
        this.props.getDirectoryDocuments(this.state.parentDirectoryId);
      }
    });
  }
  handleNavigate(e: any, dir: any) {
    this.props.getDirectoryDocuments(dir.id);
    this.setState({
      breadcrumbs: [...this.state.breadcrumbs, `${dir.name}`],
      breadcrumbsFiles: [...this.state.breadcrumbs, `${dir.name}`],
      activeTopBar: false,
      parentDirectoryId: dir.id,
    });
  }
  handleClick(crumb: any) {
    this.state.breadcrumbs.splice(this.state.breadcrumbs.indexOf(crumb - 1));
    this.state.breadcrumbsFiles.splice(
      this.state.breadcrumbsFiles.indexOf(crumb - 1)
    );
    this.setState({
      breadcrumbs: this.state.breadcrumbs,
      breadcrumbsFiles: this.state.breadcrumbsFiles,
      activeTopBar: this.state.breadcrumbs.length === 1,
      parentDirectoryId:
        this.props.Documents.root_documents_directories_list?.directories.find(
          (dir: any) => dir.name === crumb
        )?.id,
    });

    this.state.breadcrumbs.length > 1 &&
      this.props.getDirectoryDocuments(
        this.props.Documents.root_documents_directories_list?.directories.find(
          (dir: any) => dir.name === crumb
        )?.id
      );
  }
  TreeRender = (data: any, index: any) => {
    // const isChildren = data.children !== null;
    // if (isChildren) {
    //   return (
    //     <TreeItem key={data.name} nodeId={data.name} label={data.name}>
    //       {data.children.map((node, idx) => TreeRender(node))}
    //     </TreeItem>
    //   );
    // }
    return (
      <TreeItem
        onClick={() => this.handleTreeItem(data.id, index)}
        key={data.id}
        icon={<FolderIcon style={{ color: "#7C88B1" }} />}
        nodeId={`${index + 2}`}
        label={data.name}
        style={{ padding: "12px" }}
      />
    );
  };
  render() {
    const { t, classes } = this.props;
    return (
      !this.state.loading && (
        <div>
          <ModalAddDocumentInDirectory />

          <Paper style={{ margin: "3vh" }}>
            <Container style={{ padding: "20px" }}>
              <Button
                style={{ textTransform: "none" }}
                onClick={(e: any) =>
                  this.props.show("add_doc_directory", {
                    name: "add_doc_directory",
                    history,
                    actionDone: "DOCUMENT",
                    parentDirectoryId: this.state.parentDirectoryId,
                  })
                }
              >
                <AddCircleOutlineIcon
                  style={{
                    color: "#ae0064",
                    marginRight: "20px",
                  }}
                />
                {t("ADD_DOCUMENT")}
              </Button>
              <Button
                style={{ textTransform: "none" }}
                onClick={(e: any) =>
                  this.props.show("add_doc_directory", {
                    name: "add_doc_directory",
                    history,
                    actionDone: "DIRECTORY",
                    parentDirectoryId: this.state.parentDirectoryId,
                  })
                }
              >
                <AddCircleOutlineIcon
                  style={{
                    color: "#ae0064",
                    marginRight: "20px",
                  }}
                />
                {t("ADD_DIRECTORY")}
              </Button>
            </Container>
            {/* MAIN */}
            {this.state.breadcrumbs.length > 1 && (
              <Container className={classes.backContainer}>
                <Link
                  key={this.state.breadcrumbs}
                  id={this.state.breadcrumbs}
                  className={classes.breadcrumbLink}
                  onClick={() =>
                    this.handleClick(
                      this.state.breadcrumbs[this.state.breadcrumbs.length - 2]
                    )
                  }
                >
                  <Fab className={classes.fab}>
                    <ArrowBackIosIcon className={classes.arrow} />
                  </Fab>
                  <Typography className={classes.breadcrumbLinkTypography}>
                    <FolderIcon
                      style={{
                        padding: "6px",
                        height: "50px",
                        width: "50px",
                        color: "#AE0064",
                      }}
                      className={classes.materialIcons}
                    ></FolderIcon>
                    {this.state.breadcrumbs[this.state.breadcrumbs.length - 1]
                      .length > 45
                      ? this.state.breadcrumbs[
                          this.state.breadcrumbs.length - 1
                        ].slice(0, 45) + "..."
                      : this.state.breadcrumbs[
                          this.state.breadcrumbs.length - 1
                        ]}
                  </Typography>
                </Link>
              </Container>
            )}
            <main id="main" className={classes.mainContainer}>
              {this.props.Documents.directory_documents &&
              this.state.breadcrumbs.length !== 1 ? (
                <>
                  {this.props.Documents?.directory_documents.directories?.map(
                    (dir: any) => (
                      <Card
                        onMouseLeave={() => this.setState({ openActions: "" })}
                        onMouseEnter={() =>
                          this.setState({ openActions: dir.id })
                        }
                        key={dir.id}
                        onClick={(e) => this.handleNavigate(e, dir)}
                        className={classes.cardContainer}
                      >
                        <CardContent className={classes.cardContent}>
                          <FolderIcon
                            style={{
                              height: "50px",
                              width: "50px",
                              color: "#AE0064",
                            }}
                            key={dir.name}
                            className={classes.materialIcons}
                          ></FolderIcon>
                          <text className={classes.docName}>
                            {dir.name.length > 35
                              ? dir.name.slice(0, 35) + "..."
                              : dir.name}
                          </text>
                        </CardContent>
                        <CardActions
                          style={{
                            display: `${
                              this.state.openActions === dir.id
                                ? "block"
                                : "none"
                            }`,
                            height: "1vh",
                            float: "right",
                            marginTop: "4vh",
                          }}
                        >
                          <IconButton
                            style={{ marginTop: "-2vh" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.handleDeleteDirectory(dir.id);
                            }}
                            aria-label="settings"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </CardActions>
                      </Card>
                    )
                  )}
                  {this.props.Documents?.directory_documents.documents?.map(
                    (doc: any) => (
                      <Card
                        onMouseLeave={() => this.setState({ openActions: "" })}
                        onMouseEnter={() =>
                          this.setState({ openActions: doc.id })
                        }
                        key={doc.id}
                        onClick={() => {
                          this.handlePreview(doc);
                          this.setState({
                            breadcrumbsFiles: [
                              ...this.state.breadcrumbsFiles,
                              `${doc.name}`,
                            ],
                          });
                        }}
                        className={classes.cardContainer}
                      >
                        <CardContent className={classes.cardContent}>
                          <AiOutlineFilePdf
                            style={{
                              height: "50px",
                              width: "50px",
                              color: "#AE0064",
                            }}
                            className={classes.materialIconsFile}
                          />
                          <h1 className={classes.docName}>
                            {doc.name.length > 35
                              ? doc.name.slice(0, 35) + "..."
                              : doc.name}
                          </h1>
                        </CardContent>
                        <CardActions
                          style={{
                            display: `${
                              this.state.openActions === doc.id
                                ? "block"
                                : "none"
                            }`,
                            height: "1vh",
                            float: "right",
                            marginTop: "4vh",
                          }}
                        >
                          <IconButton
                            style={{ marginTop: "-2vh" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.handleDeleteDocument(doc.id);
                            }}
                            aria-label="settings"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </CardActions>
                      </Card>
                    )
                  )}
                </>
              ) : (
                <>
                  {this.props.Documents?.root_documents_directories_list?.directories?.map(
                    (rootDir: any) => (
                      <Card
                        onMouseLeave={() => this.setState({ openActions: "" })}
                        onMouseEnter={() =>
                          this.setState({ openActions: rootDir.id })
                        }
                        key={rootDir.id}
                        onClick={(e) => this.handleNavigate(e, rootDir)}
                        className={classes.cardContainer}
                      >
                        <CardContent className={classes.cardContent}>
                          <FolderIcon
                            style={{
                              height: "50px",
                              width: "50px",
                              color: "#AE0064",
                            }}
                            className={classes.materialIcons}
                          ></FolderIcon>
                          <text className={classes.docName}>
                            {rootDir.name?.length > 35
                              ? rootDir.name.slice(0, 35) + "..."
                              : rootDir.name}
                          </text>
                        </CardContent>
                        <CardActions
                          style={{
                            display: `${
                              this.state.openActions === rootDir.id
                                ? "block"
                                : "none"
                            }`,
                            height: "1vh",
                            float: "right",
                            marginTop: "4vh",
                          }}
                        >
                          <IconButton
                            style={{ marginTop: "-2vh" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.handleDeleteDirectory(rootDir.id);
                            }}
                            aria-label="settings"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </CardActions>
                      </Card>
                    )
                  )}
                  {this.props.Documents?.root_documents_directories_list?.documents?.map(
                    (rootDoc: any) => (
                      <Card
                        onMouseLeave={() => this.setState({ openActions: "" })}
                        onMouseEnter={() =>
                          this.setState({ openActions: rootDoc.id })
                        }
                        key={rootDoc.id}
                        onClick={() => {
                          this.handlePreview(rootDoc);
                          this.setState({
                            breadcrumbsFiles: [
                              ...this.state.breadcrumbsFiles,
                              `${rootDoc.name}`,
                            ],
                          });
                        }}
                        className={classes.cardContainer}
                      >
                        <CardContent className={classes.cardContent}>
                          <AiOutlineFilePdf
                            style={{
                              height: "50px",
                              width: "50px",
                              color: "#AE0064",
                            }}
                            className={classes.materialIconsFile}
                          />
                          <h1 className={classes.docName}>
                            {rootDoc.name?.length > 35
                              ? rootDoc.name.slice(0, 35) + "..."
                              : rootDoc.name}
                          </h1>
                        </CardContent>
                        <CardActions
                          style={{
                            display: `${
                              this.state.openActions === rootDoc.id
                                ? "block"
                                : "none"
                            }`,
                            height: "1vh",
                            float: "right",
                            marginTop: "4vh",
                          }}
                        >
                          <IconButton
                            style={{ marginTop: "-2vh" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.handleDeleteDocument(rootDoc.id);
                            }}
                            aria-label="settings"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </CardActions>
                      </Card>
                    )
                  )}
                </>
              )}
            </main>
          </Paper>
        </div>
      )
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getRootDocumentsAndDirectories,
  getDirectoryDocuments,
  getDocument,
  deleteDocument,
  deleteDirectory,
  show,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Funds)));
